import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5f7568b0 = () => interopDefault(import('../pages/addCreditCard.vue' /* webpackChunkName: "pages/addCreditCard" */))
const _2161b8d6 = () => interopDefault(import('../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _5179f60a = () => interopDefault(import('../pages/highlightSection.vue' /* webpackChunkName: "pages/highlightSection" */))
const _7260f649 = () => interopDefault(import('../pages/home.vue' /* webpackChunkName: "pages/home" */))
const _a4cc8e56 = () => interopDefault(import('../pages/informationStation/index.vue' /* webpackChunkName: "pages/informationStation/index" */))
const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _178eea04 = () => interopDefault(import('../pages/member.vue' /* webpackChunkName: "pages/member" */))
const _8c7f0404 = () => interopDefault(import('../pages/member/accountSetting.vue' /* webpackChunkName: "pages/member/accountSetting" */))
const _77a49c69 = () => interopDefault(import('../pages/member/address.vue' /* webpackChunkName: "pages/member/address" */))
const _d6b73358 = () => interopDefault(import('../pages/member/bonus.vue' /* webpackChunkName: "pages/member/bonus" */))
const _96d04452 = () => interopDefault(import('../pages/member/bonus/index.vue' /* webpackChunkName: "pages/member/bonus/index" */))
const _d8dda62c = () => interopDefault(import('../pages/member/bonus/listEnterprise.vue' /* webpackChunkName: "pages/member/bonus/listEnterprise" */))
const _29d056c6 = () => interopDefault(import('../pages/member/bonus/listGet.vue' /* webpackChunkName: "pages/member/bonus/listGet" */))
const _17ebfff4 = () => interopDefault(import('../pages/member/bonus/listUsed.vue' /* webpackChunkName: "pages/member/bonus/listUsed" */))
const _1ca4ccd1 = () => interopDefault(import('../pages/member/creditCardBinding.vue' /* webpackChunkName: "pages/member/creditCardBinding" */))
const _27679e03 = () => interopDefault(import('../pages/member/order.vue' /* webpackChunkName: "pages/member/order" */))
const _2b12fdd8 = () => interopDefault(import('../pages/member/order/quotationInfo/_idsn.vue' /* webpackChunkName: "pages/member/order/quotationInfo/_idsn" */))
const _6305e4ee = () => interopDefault(import('../pages/member/order/_idsn.vue' /* webpackChunkName: "pages/member/order/_idsn" */))
const _48c58641 = () => interopDefault(import('../pages/member/orderList.vue' /* webpackChunkName: "pages/member/orderList" */))
const _54e6cb6c = () => interopDefault(import('../pages/member/orderList/_id.vue' /* webpackChunkName: "pages/member/orderList/_id" */))
const _42f2b0ad = () => interopDefault(import('../pages/member/receipt.vue' /* webpackChunkName: "pages/member/receipt" */))
const _17a26027 = () => interopDefault(import('../pages/member/ticket.vue' /* webpackChunkName: "pages/member/ticket" */))
const _618c252c = () => interopDefault(import('../pages/member/ticket/index.vue' /* webpackChunkName: "pages/member/ticket/index" */))
const _cb1c8d94 = () => interopDefault(import('../pages/member/ticket/list.vue' /* webpackChunkName: "pages/member/ticket/list" */))
const _3a915da8 = () => interopDefault(import('../pages/memberUpgrade.vue' /* webpackChunkName: "pages/memberUpgrade" */))
const _6b5ed6c9 = () => interopDefault(import('../pages/menu.vue' /* webpackChunkName: "pages/menu" */))
const _2e9f220c = () => interopDefault(import('../pages/payment.vue' /* webpackChunkName: "pages/payment" */))
const _4436b7ec = () => interopDefault(import('../pages/payment/pluspay/_idHashCodeSn.vue' /* webpackChunkName: "pages/payment/pluspay/_idHashCodeSn" */))
const _92d70826 = () => interopDefault(import('../pages/payment/_idHashCodeSn.vue' /* webpackChunkName: "pages/payment/_idHashCodeSn" */))
const _cb95590e = () => interopDefault(import('../pages/serviceList.vue' /* webpackChunkName: "pages/serviceList" */))
const _0f65648b = () => interopDefault(import('../pages/serviceMultiplePackage.vue' /* webpackChunkName: "pages/serviceMultiplePackage" */))
const _757465be = () => interopDefault(import('../pages/activity/smsOrder/index.vue' /* webpackChunkName: "pages/activity/smsOrder/index" */))
const _b92bd310 = () => interopDefault(import('../pages/activity/eLifeMall/inspectionForm.vue' /* webpackChunkName: "pages/activity/eLifeMall/inspectionForm" */))
const _ce6741ae = () => interopDefault(import('../pages/logisticsOld/multiplePackage/print/_idsn.vue' /* webpackChunkName: "pages/logisticsOld/multiplePackage/print/_idsn" */))
const _6f36e655 = () => interopDefault(import('../pages/activity/agentOrder/_idsn.vue' /* webpackChunkName: "pages/activity/agentOrder/_idsn" */))
const _2ae7a982 = () => interopDefault(import('../pages/informationStation/article/_idsn.vue' /* webpackChunkName: "pages/informationStation/article/_idsn" */))
const _7fbbf686 = () => interopDefault(import('../pages/logistics/print/_idsn.vue' /* webpackChunkName: "pages/logistics/print/_idsn" */))
const _24898aea = () => interopDefault(import('../pages/logisticsOld/multiplePackage/_idsn.vue' /* webpackChunkName: "pages/logisticsOld/multiplePackage/_idsn" */))
const _13964450 = () => interopDefault(import('../pages/auth/_action.vue' /* webpackChunkName: "pages/auth/_action" */))
const _339d5c29 = () => interopDefault(import('../pages/laundry/_idsn.vue' /* webpackChunkName: "pages/laundry/_idsn" */))
const _b2157f1e = () => interopDefault(import('../pages/laundryNCS/_idsn.vue' /* webpackChunkName: "pages/laundryNCS/_idsn" */))
const _19519f1f = () => interopDefault(import('../pages/logistics/_idsn.vue' /* webpackChunkName: "pages/logistics/_idsn" */))
const _bf501978 = () => interopDefault(import('../pages/logisticsOld/_idsn.vue' /* webpackChunkName: "pages/logisticsOld/_idsn" */))
const _372a197a = () => interopDefault(import('../pages/service/_service.vue' /* webpackChunkName: "pages/service/_service" */))
const _25e9162d = () => interopDefault(import('../pages/category/_category/components/RatingCard.vue' /* webpackChunkName: "pages/category/_category/components/RatingCard" */))
const _58539c99 = () => interopDefault(import('../pages/category/_category/components/RatingSummary.vue' /* webpackChunkName: "pages/category/_category/components/RatingSummary" */))
const _196bdf40 = () => interopDefault(import('../pages/category/_category/components/ServiceInfoHeader.vue' /* webpackChunkName: "pages/category/_category/components/ServiceInfoHeader" */))
const _21988062 = () => interopDefault(import('../pages/category/_category/_service/index.vue' /* webpackChunkName: "pages/category/_category/_service/index" */))
const _8c7e4850 = () => interopDefault(import('../pages/categoryOld/_category/_service.vue' /* webpackChunkName: "pages/categoryOld/_category/_service" */))
const _147f205b = () => interopDefault(import('../pages/categoryOld/_category/_service/index.vue' /* webpackChunkName: "pages/categoryOld/_category/_service/index" */))
const _5d7a9f28 = () => interopDefault(import('../pages/categoryOld/_category/_service/comment.vue' /* webpackChunkName: "pages/categoryOld/_category/_service/comment" */))
const _a058926c = () => interopDefault(import('../pages/categoryOld/_category/_service/notes.vue' /* webpackChunkName: "pages/categoryOld/_category/_service/notes" */))
const _7426d55c = () => interopDefault(import('../pages/categoryOld/_category/_service/price.vue' /* webpackChunkName: "pages/categoryOld/_category/_service/price" */))
const _130f8e21 = () => interopDefault(import('../pages/category/_category/_service/purchase.vue' /* webpackChunkName: "pages/category/_category/_service/purchase" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f3cf0ffa = () => interopDefault(import('../pages/index/_id.vue' /* webpackChunkName: "pages/index/_id" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/addCreditCard",
    component: _5f7568b0,
    name: "addCreditCard"
  }, {
    path: "/auth",
    component: _2161b8d6,
    name: "auth"
  }, {
    path: "/highlightSection",
    component: _5179f60a,
    name: "highlightSection"
  }, {
    path: "/home",
    component: _7260f649,
    name: "home"
  }, {
    path: "/informationStation",
    component: _a4cc8e56,
    name: "informationStation"
  }, {
    path: "/login",
    component: _10ba8d22,
    name: "login"
  }, {
    path: "/member",
    component: _178eea04,
    name: "member",
    children: [{
      path: "accountSetting",
      component: _8c7f0404,
      name: "member-accountSetting"
    }, {
      path: "address",
      component: _77a49c69,
      name: "member-address"
    }, {
      path: "bonus",
      component: _d6b73358,
      children: [{
        path: "",
        component: _96d04452,
        name: "member-bonus"
      }, {
        path: "listEnterprise",
        component: _d8dda62c,
        name: "member-bonus-listEnterprise"
      }, {
        path: "listGet",
        component: _29d056c6,
        name: "member-bonus-listGet"
      }, {
        path: "listUsed",
        component: _17ebfff4,
        name: "member-bonus-listUsed"
      }]
    }, {
      path: "creditCardBinding",
      component: _1ca4ccd1,
      name: "member-creditCardBinding"
    }, {
      path: "order",
      component: _27679e03,
      name: "member-order",
      children: [{
        path: "quotationInfo/:idsn?",
        component: _2b12fdd8,
        name: "member-order-quotationInfo-idsn"
      }, {
        path: ":idsn?",
        component: _6305e4ee,
        name: "member-order-idsn"
      }]
    }, {
      path: "orderList",
      component: _48c58641,
      name: "member-orderList",
      children: [{
        path: ":id?",
        component: _54e6cb6c,
        name: "member-orderList-id"
      }]
    }, {
      path: "receipt",
      component: _42f2b0ad,
      name: "member-receipt"
    }, {
      path: "ticket",
      component: _17a26027,
      children: [{
        path: "",
        component: _618c252c,
        name: "member-ticket"
      }, {
        path: "list",
        component: _cb1c8d94,
        name: "member-ticket-list"
      }]
    }]
  }, {
    path: "/memberUpgrade",
    component: _3a915da8,
    name: "memberUpgrade"
  }, {
    path: "/menu",
    component: _6b5ed6c9,
    name: "menu"
  }, {
    path: "/payment",
    component: _2e9f220c,
    name: "payment",
    children: [{
      path: "pluspay/:idHashCodeSn?",
      component: _4436b7ec,
      name: "payment-pluspay-idHashCodeSn"
    }, {
      path: ":idHashCodeSn?",
      component: _92d70826,
      name: "payment-idHashCodeSn"
    }]
  }, {
    path: "/serviceList",
    component: _cb95590e,
    name: "serviceList"
  }, {
    path: "/serviceMultiplePackage",
    component: _0f65648b,
    name: "serviceMultiplePackage"
  }, {
    path: "/activity/smsOrder",
    component: _757465be,
    name: "activity-smsOrder"
  }, {
    path: "/activity/eLifeMall/inspectionForm",
    component: _b92bd310,
    name: "activity-eLifeMall-inspectionForm"
  }, {
    path: "/logisticsOld/multiplePackage/print/:idsn?",
    component: _ce6741ae,
    name: "logisticsOld-multiplePackage-print-idsn"
  }, {
    path: "/activity/agentOrder/:idsn?",
    component: _6f36e655,
    name: "activity-agentOrder-idsn"
  }, {
    path: "/informationStation/article/:idsn?",
    component: _2ae7a982,
    name: "informationStation-article-idsn"
  }, {
    path: "/logistics/print/:idsn?",
    component: _7fbbf686,
    name: "logistics-print-idsn"
  }, {
    path: "/logisticsOld/multiplePackage/:idsn?",
    component: _24898aea,
    name: "logisticsOld-multiplePackage-idsn"
  }, {
    path: "/auth/:action",
    component: _13964450,
    name: "auth-action"
  }, {
    path: "/laundry/:idsn?",
    component: _339d5c29,
    name: "laundry-idsn"
  }, {
    path: "/laundryNCS/:idsn?",
    component: _b2157f1e,
    name: "laundryNCS-idsn"
  }, {
    path: "/logistics/:idsn?",
    component: _19519f1f,
    name: "logistics-idsn"
  }, {
    path: "/logisticsOld/:idsn?",
    component: _bf501978,
    name: "logisticsOld-idsn"
  }, {
    path: "/service/:service?",
    component: _372a197a,
    name: "service-service"
  }, {
    path: "/category/:category?/components/RatingCard",
    component: _25e9162d,
    name: "category-category-components-RatingCard"
  }, {
    path: "/category/:category?/components/RatingSummary",
    component: _58539c99,
    name: "category-category-components-RatingSummary"
  }, {
    path: "/category/:category?/components/ServiceInfoHeader",
    component: _196bdf40,
    name: "category-category-components-ServiceInfoHeader"
  }, {
    path: "/category/:category?/:service?",
    component: _21988062,
    name: "category-category-service"
  }, {
    path: "/categoryOld/:category?/:service?",
    component: _8c7e4850,
    children: [{
      path: "",
      component: _147f205b,
      name: "categoryOld-category-service"
    }, {
      path: "comment",
      component: _5d7a9f28,
      name: "categoryOld-category-service-comment"
    }, {
      path: "notes",
      component: _a058926c,
      name: "categoryOld-category-service-notes"
    }, {
      path: "price",
      component: _7426d55c,
      name: "categoryOld-category-service-price"
    }]
  }, {
    path: "/category/:category?/:service?/purchase",
    component: _130f8e21,
    name: "category-category-service-purchase"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index",
    children: [{
      path: ":id?",
      component: _f3cf0ffa,
      name: "index-id"
    }]
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
